import { render, staticRenderFns } from "./CourseContent.vue?vue&type=template&id=a5f95e22&scoped=true&"
import script from "./CourseContent.vue?vue&type=script&lang=js&"
export * from "./CourseContent.vue?vue&type=script&lang=js&"
import style0 from "./CourseContent.vue?vue&type=style&index=0&id=a5f95e22&prod&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a5f95e22",
  null
  
)

export default component.exports